import { Navigate, useLocation, useParams } from "react-router-dom";
import { eventFormPaths } from "./paths";

type LegacyEventFormRouteRedirectProps = {
  route: "admin" | "adminDetail" | "publicForm" | "status" | "policy";
};

const LegacyEventFormRouteRedirect = ({
  route,
}: LegacyEventFormRouteRedirectProps) => {
  const location = useLocation();
  const {
    formId = "",
    publicKey = "",
    publicId = "",
    policyKey = "",
  } = useParams();

  const pathname = {
    admin: eventFormPaths.admin,
    adminDetail: eventFormPaths.adminDetail(formId),
    publicForm: eventFormPaths.publicForm(publicKey),
    status: eventFormPaths.status(publicId),
    policy: eventFormPaths.policy(policyKey),
  }[route];

  return (
    <Navigate
      replace
      to={{ pathname, search: location.search, hash: location.hash }}
      state={location.state}
    />
  );
};

export default LegacyEventFormRouteRedirect;
